







































































































import Vue from 'vue'
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue'; // @ is an alias to /src
import SearchResultModal from "@/components/SearchResultModal.vue";
import io from 'socket.io-client';
import axios from 'axios';
import LanguageSelector from "@/components/LanguageSelector.vue";
import { EventBus } from "@/event-bus";
import { APP_VERSION } from "@/version";


export default {
  props: {
    source: String
  },
  components: {
    Header,
    Footer,
    SearchResultModal,
    LanguageSelector
  },
  data() {
    return {
      drawer: false,
      socket: null,
      search: null
    }
  },
  mounted() {
    // App-Start mit vorhandenem Token: das Verdikt zum Glossar einmal holen.
    // `main.ts` setzt den `x-access-token`-Header vor dem Mounten, der Aufruf
    // ist hier also bereits angemeldet. Nach dem Login stoesst `Login.vue` ihn
    // erneut an — dort laeuft dieser Hook nicht noch einmal.
    if (this.$store.getters.isLoggedIn) {
      this.$store.dispatch("glossary_permission");
    }

    const locale = localStorage.getItem("lang");
    if (locale) {
      this.setLocale(locale);
    }

    if (Vue.config.productionTip) {
      console.log(`  #####       #####  
  #     #     #     # 
  #     #           # 
  #####       #####  
  #     # ### #       
  #     # ### #       
  #####  ### ####### Inspect - ${new Date().getFullYear()}

  Version: ${APP_VERSION}`)
    }

    const ref = this

    window.addEventListener('keyup', function (event) {
      if (event.keyCode == 16) {
        ref.$store.state.key_shift = false
      }
    });

    window.addEventListener('keydown', function (event) {
      if (event.keyCode == 16) {
        ref.$store.state.key_shift = true
      }
    });

  },
 
  methods: {
    globalSearch: function () {
      this.$store.state.search_drawer = !this.$store.state.search_drawer
    },
    logout: function () {
      this.$router.push({ name: 'logout' })
    },
    inspectCompact: function () {
      this.$router.push({ name: 'inspect_compact' })
    },
    goOverview: function () {
      this.$router.push({ name: 'overview' })
    },
    goChecklist: function () {
      this.$router.push({ name: 'checklists' })
    },
    goMachineList: function () {
      this.$router.push({ name: 'machines-list' })
    },
    goMessageFormats: function () {
      this.$router.push({ name: 'message-formats' })
    },
    goMachineGroups: function () {
      this.$router.push({ name: 'machines' })
    },
    goMachineGroupsCompany: function () {
      this.$router.push({ name: 'machines-company' })
    },
    goInspections: function () {
      this.$router.push({ name: 'inspections' })
    },
    goUpdates: function () {
      this.$router.push({ name: 'updates' })
    },
    goProject: function () {
      this.$router.push({ name: 'project' })
    },
    goFinalize: function () {
      this.$router.push({ name: 'cancelfinalization' })
    },
    goBilling: function () {
      this.$router.push({ name: 'billing' })
    },
    goUser: function () {
      this.$router.push({ name: 'users' })
    },
    goGlossary: function () {
      this.$router.push({ name: 'glossary' })
    },
    dialogClosed: function (val) {
      this.showSearchResult = false
    },
    setLocale(locale) {
      console.log('setLocale', locale);
      
      if (locale) {
        this.$i18n.locale = locale;
        this.$store.state.lang = locale;
        axios.defaults.headers.common['x-lang'] = locale;
      }
    },
    onLanguageChanged(language) {
      console.log('onLanguageChanged', language);
      // 
      localStorage.setItem("lang", language.locale);
      this.setLocale(language.locale);
    },
  },
  computed: {
    searchField: function () {
      return this.$store.state.searchField;
    },
    headerT: function () {
      return this.$store.state.headerTitle;
    },
    userRole: function () {
      if (this.$store.getters.userRole) {
        return this.$store.getters.userRole
      }
      return {}
    },
    // Kommt aus `/checklist/glossary/permission` und liegt nur im State dieser
    // Sitzung. Bewusst NICHT `userRole.glossary`: `user_role` schreibt allein
    // der Login, und die Tokens laufen 30 Tage — ein von Hand gesetztes Flag
    // saehe der betroffene Nutzer bis dahin nicht.
    glossaryAllowed: function () {
      return this.$store.state.glossary_permission === true
    }
  },
  created() {
    console.log("--- ", this.$store.getters.companyId)
  }

}
